module.exports = __webpack_public_path__ + "img/hil-logo.cc43cdbd.png";